/* eslint-disable no-nested-ternary */
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { isEmail } from 'utils';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => createStyles({
    textField: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: 'auto'
      }
    }
  }));

function BookForm({ handleChangeName, handleChangePhone, handleChangeEmail, name, email, phone }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const phoneError = phone && phone.length !== 9;
  const emailError = email && !isEmail(email);
  return (
    <form className={classes.textField} noValidate autoComplete="off">
      <div>
        <TextField
          variant="outlined"
          color="secondary"
          onChange={handleChangeName}
          label={t('order-username')}
          defaultValue={name}
        />
      </div>
      <div>
        <TextField
          variant="outlined"
          color="secondary"
          type="number"
          onChange={handleChangePhone}
          label={t('order-phone-number')}
          error={!!phoneError}
          helperText={!!phoneError && 'Număr nevalid'}
          defaultValue={phone}
        />
      </div>
      <div>
        <TextField
          variant="outlined"
          color="secondary"
          type="text"
          onChange={handleChangeEmail}
          label="Email"
          error={!!emailError}
          helperText={!!emailError && 'Email nevalid'}
          defaultValue={email}
        />
      </div>
    </form>
  );
}

export default BookForm;
